<template>
    <b-alert :variant="alertVariant" show class="mb-0 p-1">
        <p class="mb-0">
            Plan de charge : {{ charge }} h | Coût : {{ cost }}€ | Budget :
            {{ budget }}€
        </p>
    </b-alert>
</template>

<script>
export default {
    name: 'ChargeSummary',

    props: {
        year: {
            type: Number,
            required: true,
        },
        clientId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            budget: '-',
            cost: '-',
            charge: '-',
            loseMoney: false,
        }
    },

    computed: {
        alertVariant() {
            return this.loseMoney ? 'danger' : 'success'
        },
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            try {
                const response = await this.$axios.get(
                    `clients/${this.clientId}/charge-summary/${this.year}`
                )
                this.budget = response.data.data.budget
                this.cost = response.data.data.cost
                this.charge = response.data.data.charge
                this.loseMoney = response.data.data.lose_money
            } catch (error) {
                //
            }
        },
    },
}
</script>

<style scoped></style>
